import HubsPotIconFile from './assets/hubspot_icon.png';

export const HubSpotIcon = ({ size = 12 }: { size?: number }) => (
  <img
    src={HubsPotIconFile}
    alt="HubSpot"
    width={size}
    height={size}
    style={{ width: size, height: size }}
  />
);
